import type { PostMessagePrioritizationRulesProps } from "./validators";

export const transformProps = (props: PostMessagePrioritizationRulesProps) => {
  return {
    rules: props.rules.map((rule) => ({
      name: rule.name,
      description: rule.description,
      campaign_filters: {
        filter_key: rule.campaignFilters.filterKey,
        filters: rule.campaignFilters.filters?.map((filterGroup) => ({
          filter_key: filterGroup.filterKey,
          filters: filterGroup.filters.map((filter) => ({
            filter_key: filter.filterKey,
            value: filter.value,
            comparison_key: filter.comparisonKey,
          })),
        })),
      },
    })),
  };
};
